import { render, staticRenderFns } from "./SliIconFile.vue?vue&type=template&id=04e9a296"
import script from "./SliIconFile.vue?vue&type=script&lang=js"
export * from "./SliIconFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports